var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-793 -707)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.875 735.333h-2.292v4.606h-2.291v-4.606H793v6.908h4.583V747h2.292v-4.759h2.292v-2.302h-2.292zM820.708 735.333h-2.291v4.606h-2.292v-4.606h-2.292v6.908h4.584V747h2.291v-4.759H823v-2.302h-2.292zM804.667 747h6.666v-11.667h-6.666V747zm2.222-9.364h2.222v7.061h-2.222v-7.061zM806.333 714.5h2.5v9.167h-2.5zM806.333 725.333h2.5v2.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.462 732.833h23.076c2.731 0 4.36-3.07 2.936-5.388l-11.537-18.788a3.43 3.43 0 0 0-5.874 0l-11.537 18.788c-1.422 2.315.203 5.388 2.936 5.388zm-.98-4.143 11.538-18.788a1.145 1.145 0 0 1 1.96 0l11.537 18.788c.474.772-.07 1.795-.98 1.795h-23.075c-.909 0-1.454-1.023-.98-1.795z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.fd23008f834a00a6f08426ce8333db82.svg";
export { ForwardRef as ReactComponent };